export default __webpack_public_path__ + "static/peopleBirthdayBg-dc1aff916b265c5b7e0e81ebdffaaf2c.png";